import React from 'react';

interface IIfProps {
    condition?: any|null;
}

export const If: React.FC<IIfProps> = ({
    children,
    condition
}) => {

    if (!condition) return null;
    
    return (<>{children}</>);
}